import React from "react";
import { Table } from "antd";

const Activity = ({ userId, data }) => {
  const columns = [
    {
      title: "date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "ip",
      dataIndex: "ip",
      key: "ip",
    },
    {
      title: "message",
      dataIndex: "message",
      key: "message",
    },
  ];

  return <Table dataSource={data} columns={columns} />;
};
export default Activity;
